import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Input,
  Table,
  Card,
  CardBody,
  Row,
  Col,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import SuburbService from "../../../services/SuburbServices/SuburbService";
import toast from "react-hot-toast";
import countriesJson from "../json/country.json"; // Replace with your actual path
import CountryService from "../../../services/CountryServices/CountryService";

const CountryForm = ({
  isOpen,
  toggle,
  countryToEdit,
  onRefresh,
  setCountryData,
  countryData,
  fetchCountries,
}) => {
  console.log("🚀 ~ countryToEdit:", countryToEdit);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const formik = useFormik({
    initialValues: {
      name: "",
      code: "",
      state_label: "Province",
      suburb_label: "City",
      is_active: 1,
      states: [],
      // zip: []
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Country name is required"),
      code: Yup.string().required("Country code is required"),
      state_label: Yup.string().required("State label is required"),
      suburb_label: Yup.string().required("Suburb label is required"),
      is_active: Yup.number().required("Status is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          ...values,
          states: values.states.map((state) => ({
            ...state,
            is_active: state.is_active ?? 1,
          })),
          // zip: values.zip.map(zipItem => ({
          //   code: zipItem.code
          // }))
        };

        if (countryToEdit) {
          const response = await CountryService.update(
            countryToEdit.id,
            payload
          );
          setCountryData((prev) =>
            prev.map((item) =>
              item.id === countryToEdit.id ? response.data : item
            )
          );
          toast.success("Country updated successfully");
        } else {
          const response = await CountryService.create(payload);
          setCountryData((prev) => [...prev, response.data]);
          toast.success("Country created successfully");
          
        }
        fetchCountries();
        toggle();
      } catch (error) {
        console.error("Error saving country:", error);
        toast.error("An error occurred while saving the country");
      } finally {
        setLoading(false);
      }
    },
  });
  const handleDeleteState = (index) => {
    const updated = [...formik.values.states];
    updated.splice(index, 1);
    formik.setFieldValue("states", updated);
    formik.setFieldTouched("states", true, false);
    
    // If needed, you could also manually update the countryToEdit reference
    if (countryToEdit && countryToEdit.states) {
      countryToEdit.states = updated;
    }
  };
  useEffect(() => {
    if (countryToEdit) {
      formik.setValues({
        name: countryToEdit.name || "",
        code: countryToEdit.code || "",
        state_label: countryToEdit.state_label || "Province",
        suburb_label: countryToEdit.suburb_label || "City",
        is_active: countryToEdit.is_active ?? 1,
        states: countryToEdit.states || [],
        // zip: countryToEdit.zip || []
      });
    } else {
      formik.resetForm();
    }
  }, [countryToEdit]);

  useEffect(() => {
    if (!isOpen) formik.resetForm();
  }, [isOpen]);

  const tabToggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const renderStateRows = () =>
    formik.values.states.map((state, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>
          <Input
            type="text"
            name={`states[${index}].name`}
            value={state.name}
            onChange={formik.handleChange}
            placeholder={`Enter ${formik.values.state_label} name`}
            bsSize="sm"
          />
        </td>
        <td>
          <Input
            type="text"
            name={`states[${index}].code`}
            value={state.code}
            onChange={formik.handleChange}
            placeholder={`Enter ${formik.values.state_label} code`}
            bsSize="sm"
          />
        </td>
        <td>
          <Input
            type="select"
            name={`states[${index}].is_active`}
            value={state.is_active || 1}
            onChange={formik.handleChange}
            bsSize="sm"
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </Input>
        </td>
        <td>
          <Button
            color="danger"
            size="sm"
            onClick={() => handleDeleteState(index)}
          >
            <i className="bx bx-minus"></i>
          </Button>
        </td>
      </tr>
    ));

  // const renderZipRows = () =>
  //   formik.values.zip.map((zipItem, index) => (
  //     <tr key={index}>
  //       <td>{index + 1}</td>
  //       <td>
  //         <Input
  //           type="text"
  //           name={`zip[${index}].code`}
  //           value={zipItem.code}
  //           onChange={formik.handleChange}
  //           placeholder="Enter zip code"
  //           bsSize="sm"
  //         />
  //       </td>
  //       <td>
  //         <Button
  //           color="danger"
  //           size="sm"
  //           onClick={() => {
  //             const updated = [...formik.values.zip];
  //             updated.splice(index, 1);
  //             formik.setFieldValue("zip", updated);
  //           }}
  //         >
  //           <i className="bx bx-minus"></i>
  //         </Button>
  //       </td>
  //     </tr>
  //   ));

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {countryToEdit ? "Edit Country" : "Add Country"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <Row>
            <Col xs={12} md={6} lg={6}>
              <div className="form-floating mb-3">
                <Input
                  name="name"
                  className="form-control"
                  placeholder="Enter country name"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name || ""}
                  invalid={!!(formik.touched.name && formik.errors.name)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="floatingInput">Country Name</Label>
                {formik.touched.name && formik.errors.name && (
                  <FormFeedback type="invalid">
                    {formik.errors.name}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col xs={12} md={6} lg={6}>
              <div className="form-floating mb-3">
                <Input
                  name="code"
                  className="form-control"
                  placeholder="Enter country code"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.code || ""}
                  invalid={!!(formik.touched.code && formik.errors.code)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="floatingInput">Country Code</Label>
                {formik.touched.code && formik.errors.code && (
                  <FormFeedback type="invalid">
                    {formik.errors.code}
                  </FormFeedback>
                )}
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={6}>
              <div className="form-floating mb-3">
                <Input
                  name="state_label"
                  className="form-control"
                  placeholder="Enter state label"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.state_label || ""}
                  invalid={
                    !!(formik.touched.state_label && formik.errors.state_label)
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="floatingInput">State Label</Label>
                {formik.touched.state_label && formik.errors.state_label && (
                  <FormFeedback type="invalid">
                    {formik.errors.state_label}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col xs={12} md={6} lg={6}>
              <div className="form-floating mb-3">
                <Input
                  name="suburb_label"
                  className="form-control"
                  placeholder="Enter suburb label"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.suburb_label || ""}
                  invalid={
                    !!(
                      formik.touched.suburb_label && formik.errors.suburb_label
                    )
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="floatingInput">Suburb Label</Label>
                {formik.touched.suburb_label && formik.errors.suburb_label && (
                  <FormFeedback type="invalid">
                    {formik.errors.suburb_label}
                  </FormFeedback>
                )}
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} md={6} lg={6}>
              <div className="form-floating">
                <Input
                  name="is_active"
                  className="form-control"
                  type="select"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.is_active}
                  invalid={
                    !!(formik.touched.is_active && formik.errors.is_active)
                  }
                  style={{ padding: "0.5rem", height: "38px" }}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </Input>
                <Label for="floatingInput">Status</Label>
                {formik.touched.is_active && formik.errors.is_active && (
                  <FormFeedback type="invalid">
                    {formik.errors.is_active}
                  </FormFeedback>
                )}
              </div>
            </Col>
          </Row>

          <Nav
            className="nav-tabs-custom rounded card-header-tabs border-bottom-0 mb-3"
            role="tablist"
          >
            <NavItem>
              <NavLink
                className={`cursor-pointer ${
                  activeTab === "1" ? "active border-0" : ""
                }`}
                onClick={() => {
                  tabToggle("1");
                }}
              >
                {formik.values.state_label || "States"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`cursor-pointer ${
                  activeTab === "2" ? "active " : ""
                }`}
                onClick={() => {
                  tabToggle("2");
                }}
              >
                Zip Code
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <div className="pt-2">
                <CardBody>
                  <Row>
                    <Col xs={12}>
                      <Table bordered>
                        <thead>
                          <tr>
                            <th>S.N</th>
                            <th>{formik.values.state_label || "State"} Name</th>
                            <th>{formik.values.state_label || "State"} Code</th>
                            <th>Status</th>
                            <th>
                              <div className="text-end">
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    formik.setFieldValue("states", [
                                      ...(formik.values.states || []),
                                      { name: "", code: "", is_active: 1 },
                                    ])
                                  }
                                >
                                  <i className="bx bx-plus"></i>
                                </Button>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formik.values.states.length > 0 ? (
                            renderStateRows()
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                Please add a{" "}
                                {formik.values.state_label || "state"} to view
                                them here.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </TabPane>
            <TabPane tabId="2">
              <div className="pt-2">
                {/* <CardBody>
                  <Row>
                    <Col xs={12}>
                      <Table bordered>
                        <thead>
                          <tr>
                            <th>S.N</th>
                            <th>Zip Code</th>
                            <th>
                              <div className="text-end">
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    formik.setFieldValue("zip", [
                                      ...(formik.values.zip || []),
                                      { code: "" },
                                    ])
                                  }
                                >
                                  <i className="bx bx-plus"></i> 
                                </Button>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formik.values.zip.length > 0 ? (
                            renderZipRows()
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                Please add a zip code to view them here.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardBody> */}
              </div>
            </TabPane>
          </TabContent>

          <div className="d-flex gap-2 justify-content-end">
            <Button type="button" color="danger" onClick={toggle}>
              Cancel
            </Button>
            <Button type="submit" color="success" disabled={loading}>
              {countryToEdit ? "Update" : "Create"}
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default CountryForm;
